
















import { defineComponent, PropType } from '@vue/composition-api'
import UploadFileItem from './UploadFileItem.vue'
import { Conversation } from '@/rest/conversations-api'

export default defineComponent({
  components: {
    UploadFileItem
  },

  props: {
    conversationId: String,
    conversation: {} as PropType<Conversation>,
    files: Array as PropType<Array<File>>
  },

  setup() {}
})
